import { Card, Flex } from "antd";

import {
  DepositStatuses,
  OpenAccountsReceivableStatuses,
} from "financials/components";
import {
  IDepositStatus,
  IOpenAccountsReceivableStatus,
} from "financials/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  depositStatuses?: IDepositStatus[];
  openAccountsReceivableStatuses?: IOpenAccountsReceivableStatus[];
};

export const FinanceManagerFinancialsChartsCard = ({
  loading,
  depositStatuses,
  openAccountsReceivableStatuses,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='financeManagerFinancialsChartsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Financials</h1>
        <DepositStatuses depositStatuses={depositStatuses ?? []} height={500} />
        <OpenAccountsReceivableStatuses openAccountsReceivableStatuses={openAccountsReceivableStatuses ?? []} height={500} />
      </Flex>
    </Card>
  );
};
